import React from 'react';
import Icon from 'icons/Icon';
import RoleHelper from '../../RoleHelper';
import ComponentName from '../../constant/ComponentName';
import LanguageUtil from '../../util/LanguageUtil';
import CustomDismissible from './CustomDismissible';
import { RuleTypes } from '../../domain/collection/rule/RuleDomains';

interface RuleCreateDropdownProps {
  onNavigate: (path: string) => void;
  onDismiss: () => void;
  id?: string;
}

const RuleCreateDropdown: React.FC<RuleCreateDropdownProps> = ({ onNavigate, onDismiss, id = 'rule' }) => {
  const getCreateItems = () => {
    return (
      <CustomDismissible id={`item-tools-${id}`} onDismiss={onDismiss}>
        <div className='flex flex-col text-xs items-start justify-center w-40'>
          {Object.values(RuleTypes).map(
            (type) =>
              RoleHelper.canEdit('Rule') && (
                <p
                  key={type}
                  onClick={() => onNavigate(type)}
                  data-testid={`${ComponentName.RULE}_create_${type}`}
                  className='hover:bg-main-gray px-3 py-3 indent-1 hover:cursor-pointer w-full flex items-center whitespace-nowrap rounded-md'
                >
                  <Icon icon={type} width={16} height={16} />
                  {LanguageUtil.get({
                    id: `pages.rule.types.${type}Rule`,
                    defaultMessage: type,
                  })}
                </p>
              ),
          )}
        </div>
      </CustomDismissible>
    );
  };

  return getCreateItems();
};

export default RuleCreateDropdown;
